import React from 'react';
import SBVolleyball from './SBVolleyball.js'
import TeamSettings from '../lib/TeamSettings.js'
import Game from '../lib/Game.js'
import LineUp from './LineUp.js'
import RefereeSettings from '../lib/RefereeSettings.js'
import CrewSettings from '../lib/CrewSettings.js'
import OverlayConfig from '../../overlayconfig/OverlayConfig.js'
import OutputConfig from '../../outputconfig/OutputConfig.js'

class Volleyball extends React.Component {

  constructor(props) {
			super(props);
			this.state = {
						currentView : this.props.view !== undefined?this.props.view:this.props.gameTypes+"SB",
			};
  }

  onMenu(f) {
		this.setState({currentView:f});
	}

	componentWillMount() {
		if(this.props.scoreboard!== undefined && this.props.scoreboard.registerEventHandler !== undefined) {
				this.props.scoreboard.registerEventHandler("Volleyball",this);
		}
	}

	render(){
		switch (this.state.currentView) {
			case 'Volleyball_TeamSettings':
					return (<TeamSettings  gameTypes={this.props.gameTypes} setGameType={this.props.setGameType} guppyi={this.props.guppyi}/>)
      case 'Volleyball_Game':
    			return (<Game  gameTypes={this.props.gameTypes} setGameType={this.props.setGameType} guppyi={this.props.guppyi}/>)
      case 'Volleyball_OverlayConfig':
          return (<OverlayConfig  gameTypes={this.props.gameTypes} setGameType={this.props.setGameType} guppyi={this.props.guppyi}/>)
      case 'Volleyball_LineUp':
          return (<LineUp  gameTypes={this.props.gameTypes} setGameType={this.props.setGameType} guppyi={this.props.guppyi}/>)
      case 'Volleyball_Referee':
              return (<RefereeSettings gameTypes={this.props.gameTypes} setGameType={this.props.setGameType} guppyi={this.props.guppyi}/>)
      case 'Volleyball_Crew':
              return (<CrewSettings gameTypes={this.props.gameTypes} setGameType={this.props.setGameType} guppyi={this.props.guppyi}/>)
      case 'Volleyball_OutputConfig':
          return (<OutputConfig  gameTypes={this.props.gameTypes} setGameType={this.props.setGameType} guppyi={this.props.guppyi}/>)
			default:
				  return (
            <>
            {/* <SB_Volleyball  gameTypes={this.props.gameTypes} setGameType={this.props.setGameType} guppyi={this.props.guppyi}/> */}
            <SBVolleyball  gameTypes={this.props.gameTypes} setGameType={this.props.setGameType} guppyi={this.props.guppyi}/>
            </>
          )
		}
	}
}
export default Volleyball;
